module.exports = __webpack_public_path__ + "img/edit-black-icon.0340d6cb.svg";